<template lang="pug">
    v-layout(wrap )
        m-block-section-progress(:section="item" :item="question.data" :query="parseQuery")
        v-container
            component(:is="component" :item="question.data" :answers="answer"
                @submit:skip="skip"
                @submit:answer="onSubmitAnswer"
                @submit:options="optionsAnswer"
                @submit:next="next"
                @submit:notice="noticeAnswer"
                :raId="raId")
</template>

<script>
    import MBlockSectionProgress from "@modules/blocks/progress/concrete/m-block-section-progress";
    import MBlockRaQuestion from "@modules/blocks/content/risk-assessment/m-block-ra-question";
    import MBlockRaNotice from "@modules/blocks/content/risk-assessment/m-block-ra-notice";
    import MBlockRaOptions from "@modules/blocks/content/risk-assessment/m-block-ra-options";
    import MBlockRaEvaluation from "@modules/blocks/content/risk-assessment/m-block-ra-evaluation";
    import {possibleQuestionAnswers, questions} from "@constants/common";
    import {mapActions} from 'vuex';
    import {changeAnswer, getAnswer} from "@utils/assessmentAnswers";
    import vuexKeys from "@mixins/includes/_vuexKeys";
    import errorHandler from "@mixins/responses/_errorHandler";
    import notifications from "@mixins/includes/_notifications";

    let name = 'm-block-questions';
    export default {
        name: name,
        components: {MBlockRaEvaluation, MBlockSectionProgress, MBlockRaQuestion, MBlockRaNotice},
        mixins: [vuexKeys, errorHandler, notifications],
        props: {
            name: {
                type: String,
                default: name
            },
            item: {
                type: Object,
                required: true
            },
            isOnce: {
                type: Boolean,
                default: true
            },
            entryPoint: {
                type: String
            },
            answers: {
                type: Array,
                required: true
            },
            isOnboarding: {
                type: Boolean,
                default: false
            },
            raId: {
                type: String,
                required: false
            }
        },
        data: () => ({
            optionsWay: [],
            afterOption: false,
            questionNum: 0,
            optionsLevel: 1,
            storedAnswers: null
        }),
        created() {
            if (this.$route.query.once) {
                let addrOption = this.$route.query.level.slice(6).split('-').map(v => Number(v))
                let optionsWay = []
                for (let i = 0; i <= addrOption[0]; i++) {
                    optionsWay.push([])
                }
                optionsWay[addrOption[0]][0] = addrOption[1];
                this.optionsWay = optionsWay
            }
            this.storedAnswers = this.answers
        },
        mounted() {
            this.checkIfIsSection();
            // if jumped directly into child option option element, set parent element to 'yes'
            if (this.$route.query.once) {
                let parentKeys = this.$route.query.level.split('-').map(key => Number(key))
                parentKeys.splice(2)
                const parentId = this.answers[parentKeys[0]].children[parentKeys[1]].id;
                const answer = {
                    id: parentId,
                    value: 'yes'
                };
                this.storeAnswer(answer, parentKeys);
            }
        },
        computed: {
            component() {
                this.checkIfIsSection();
                switch (this.question.data.type) {
                    case questions.types.question:
                        return MBlockRaQuestion;
                    case questions.types.option:
                        return MBlockRaQuestion;
                    case questions.types.evaluation:
                        return MBlockRaEvaluation;
                    case questions.types.options:
                        return MBlockRaOptions;
                    case questions.types.notice:
                        return MBlockRaNotice;
                    default:
                        return MBlockRaNotice
                }
            },
            question() {
                let address = this.parseQuery;
                let currentPos = 1;

                const getQuestion = (parent, key) => {
                    currentPos++;

                    if (address.length - 1 > key) {
                        return getQuestion(parent[address[key]].children, key + 1)
                    } else {
                        return {data: parent[address[key]], countItems: parent.length}
                    }
                };
                return getQuestion(this.item.children, currentPos)
            },
            parseQuery() {
                return this.$route.query.level.split('-')
            },
            answer() {
                let query = this.parseQuery;
                return getAnswer(this.storedAnswers, query);
            },
            assessmentId() {
                return this.$route.params.id
            },
        },
        methods: {
            ...mapActions({
                updateAssessment: 'riskAssessments/update',
            }),
            redirectProcess() {
                if (this.isOnboarding) {
                    return this.nav.dashboard.service.onboarding_risk_assessment.process.name
                } else {
                    return this.nav.dashboard.service.risk_assessment.process.name
                }
            },
            redirectView() {
                if (this.isOnboarding) {
                    return this.nav.dashboard.service.onboarding_risk_assessment.view.name
                } else {
                    return this.nav.dashboard.service.risk_assessment.view.name
                }
            },
            skip() {
                const level = this.toNeighbourOrParent();
                if (!level) return;
                this.redirect(this.redirectProcess(), {
                    id: this.$route.params.id
                }, {level})
            },
            toNeighbourOrParent() {
                if (this.optionsWay.length) {

                    if (this.$route.query.once && this.$route.query.level.length < 10) {
                        this.redirect(this.redirectView(), {
                            id: this.$route.params.id,
                        });

                        return false
                    }

                    // checking Neighbour
                    var address = this.$route.query.level
                    let lastAdress = address.split('-').pop()
                    if (this.question.countItems !== Number(lastAdress) + 1) {
                        let newLevel = address.substr(0, address.length - lastAdress.length) + (Number(lastAdress) + 1)

                        this.redirectTo(newLevel)

                        return false
                    } else {

                        let parentAddressinCurrentOption = this.findParentWithOptions(this.$route.query.level)

                        if (this.optionsWay.filter(v => v.length).length === 0) {

                            this.afterOption = true

                            this.optionsLevel = 1

                            this.optionsWay = this.optionsWay.filter(v => {
                                return v.length
                            })

                            return this.$route.query.level ? this.findParent(this.$route.query.level) : false;
                        }

                        if (parentAddressinCurrentOption) {
                            this.redirectTo(parentAddressinCurrentOption)
                            return false
                        }

                    }

                    if (!this.optionsWay.length) this.afterOption = true

                    if (!!this.optionsWay.length) {
                        this.redirectTo(address.substr(0, 5) + '-' + this.findFirstOptionPath())
                        return false
                    }
                }

                var address = this.$route.query.level
                let lastAdress = address.split('-').pop()
                let newLevel = address.substr(0, address.length - lastAdress.length) + (Number(lastAdress) + 1)

                if (this.question.countItems === Number(lastAdress) + 1) {
                    let parentLevel = this.findParent(address);
                    if (this.isOnce && parentLevel.length <= this.entryPoint.length) {
                        this.redirect(this.nav.dashboard.service.risk_assessment.view.name, {
                            id: this.$route.params.id,
                        });

                        return false
                    }

                    return parentLevel;
                }

                if (this.isOnce && newLevel.length <= this.entryPoint.length) {
                    this.redirect(this.redirectView(), {
                        id: this.$route.params.id,
                    });

                    return false
                }
                return newLevel;
            },

            findParentWithOptions(address) {
                let levels = address.split('-')

                if (this.afterOption) {
                    this.afterOption = false
                    levels = levels.slice(0, 3)
                }

                let found = false;

                do {
                    levels = levels.slice(0, -1)

                    if (levels.length < 6) {

                        let currentPosInSection = this.$route.query.level.substr(6, 1)

                        this.optionsWay[currentPosInSection].shift();

                        this.optionsWay = this.optionsWay.map(v => {
                            if (v.length === 0) return []
                            return v
                        })

                        if (!this.optionsWay[0].length && this.isOnce) {
                            this.redirect(this.redirectView(), {
                                id: this.$route.params.id,
                            });

                            return false
                        }

                        return false

                    }

                    levels[levels.length - 1] = Number(levels[levels.length - 1]) + 1

                    if (this.checkIfExistsQuestion(this.item.children, 1, levels)) {
                        found = true
                    }
                } while (!found)

                // // For go to evaluation and skip option question
                // if (levels.length < 5) {
                //     levels.push('0')
                // }

                return levels.join('-')
            },

            findParent(address) {
                let levels = address.split('-')
                if (this.afterOption) {
                    this.afterOption = false
                    levels = levels.slice(0, 3)
                }
                let found = false;
                do {
                    levels = levels.slice(0, -1)
                    if (levels.length < 2) {

                        this.redirect(this.redirectView(), {
                            id: this.$route.params.id,
                        });

                        return false
                    }

                    levels[levels.length - 1] = Number(levels[levels.length - 1]) + 1

                    if (this.checkIfExistsQuestion(this.item.children, 1, levels)) {
                        found = true
                    } else {
                    }
                } while (!found)

                return levels.join('-')
            },
            checkIfExistsQuestion(item, key, levels) {
                if (key < levels.length - 1) {
                    return this.checkIfExistsQuestion(item[levels[key]].children, key + 1, levels)
                } else {
                    return item[levels[key]]
                }
            },

            toChildrenIfExists() {
                let withChildren = this.$route.query.level + '-0'
                try {
                    const questionExists = this.checkIfExistsQuestion(this.item.children, 1, withChildren.split('-'))
                    if (this.optionsWay.length) {
                        ++this.optionsLevel
                    }
                    return questionExists ? withChildren : this.toNeighbourOrParent()
                } catch (e) {
                    console.warn(e)
                    // do nothing, not an error from UI Perspective
                }
                return this.toNeighbourOrParent()
            },
            findFirstOptionPath() {
                let sectionKey = null;
                this.optionsWay.forEach((item, key) => {
                    if (item && item.length && sectionKey === null) {
                        sectionKey = key
                    }
                })
                return `${sectionKey}-${this.optionsWay[sectionKey][0]}-0`
            },
            addAnswer(item) {
                this.storedAnswers = changeAnswer(this.storedAnswers, item.keys, item.val, item.id)
            },
            storeAnswer(answer, parentKeys) {
                let keys = this.$route.query.level.split('-').map(key => Number(key));
                if (parentKeys) {
                    keys = parentKeys
                }
                this.addAnswer({
                    keys,
                    val: answer.value,
                    id: answer.id
                })
            },
            async saveAnswers() {
                const payload = {
                    _id: this.assessmentId,
                    configWithAnswer: this.storedAnswers
                };
                try {
                    await this.updateAssessment(payload)
                    return true
                } catch (e) {
                    if (e.response && e.response.status === 404) {
                        this.notify.error(this.$t('notifications.errors.loseRightsOnRa'))
                        this.$emit('update:needConfirmRedirect', false)
                        this.redirect(this.nav.dashboard.service.risk_assessment.index.name);
                    } else {
                        this.error.handle(e)
                    }
                    return false;
                }
            },
            redirectTo(level) {
                this.redirect(this.redirectProcess(), {
                    id: this.$route.params.id
                }, {
                    level
                })
            },
            async onSubmitAnswer(action) {
                this.storeAnswer(action);
                if (!await this.saveAnswers()) {
                    return;
                }
                const level = action.type === 'negative' ? this.toNeighbourOrParent() : this.toChildrenIfExists();
                if (!level) return;
                this.redirectTo(level)
            },
            async optionsAnswer(options) {
                //TODO optimize this method after config refactoring
                this.question.data.children.forEach((section, sectionKey) => {
                    section.children.forEach((option, optionKey) => {
                        let keys = this.$route.query.level.split('-').map(key => Number(key))
                        keys.push(sectionKey);
                        keys.push(optionKey);
                        let val = options[sectionKey].includes(optionKey) ? possibleQuestionAnswers.yes : possibleQuestionAnswers.no;
                        let answer;
                        if (!this.$lodash.isEmpty(option.actions)) {
                            answer = option.actions.actions.filter(action => action.value === val).pop()
                        }
                        this.addAnswer({
                            keys,
                            val,
                            id: answer ? answer.id : null
                        })
                    })
                });
                await this.saveAnswers();
            },
            async noticeAnswer(value) {
                this.storeAnswer({value});
                if (!await this.saveAnswers()) {
                    return;
                }
                this.redirect(this.redirectView(), {
                    id: this.$route.params.id,
                });
            },

            next(options) {
                if (this.question.data.type === 'options' && options.filter(v => v.length).length) {
                    this.optionsWay = options;
                    let optionsPath = this.findFirstOptionPath();
                    this.redirectTo(this.$route.query.level + '-' + optionsPath)
                } else {
                    const level = this.toNeighbourOrParent()
                    if (!level) return;
                    this.redirectTo(level)
                }
            },
            checkIfIsSection() {
                if (this.$route.query.level.split('-').length == 1) {
                    let baseRoute = this.$route.path;
                    let parentRoute = baseRoute.slice(0, baseRoute.lastIndexOf("/"))
                    this.$router.push({path: parentRoute})
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    //
</style>
